var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content-space-1"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col col-lg-9"},[_c('div',{staticClass:"custom-html text-dark",domProps:{"innerHTML":_vm._s(_vm.html)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }